export const recipientDomainsOptions = [
  {
    label: "This Week",
    value: "thisWeek",
  },
  {
    label: "Last Week",
    value: "lastWeek",
  },
  {
    label: "This Month",
    value: "thisMonth",
  },
  {
    label: "Last Month",
    value: "lastMonth",
  },
  {
    label: "Custom",
    value: "custom",
  },
];

export const recipientDomainsTableHeader = [
  {
    name: "Domain",
    field: "domain",
    sorting: false,
  },
  {
    name: "Requested",
    field: "requested_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Delivered (%)",
    field: "received_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Opened (%)",
    field: "opened_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Clicked (%)",
    field: "clicked_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Unsubscribed (%)",
    field: "unsubscribed_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Bounced (%)",
    field: "bounced_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Dropped (%)",
    field: "dropped_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Abuse (%)",
    field: "abuse_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Invalid (%)",
    field: "invalid_count",
    align: "center",
    sorting: false,
  },
  {
    name: "Spam (%)",
    field: "spam_count",
    align: "center",
    sorting: false,
  },
];

export const failedStatsTableHeader = [
  {
    name: "Campaign Recipient",
    field: "contactEmail",
    sorting: false,
  },
  {
    name: "Sent By",
    field: "campaignOwner",
    sorting: false,
  },
  {
    name: "Campaign Name",
    field: "campaignName",
    sorting: false,
  },
  {
    name: "Reason",
    field: "reason",
    sorting: false,
    align: "left",
  },
];

export const failedStatsBounceStatusFilter = [
  { id: 0, label: "Soft Bounced", value: "SoftBounced" },
  { id: 1, label: "Hard Bounced", value: "HardBounced" },
  { id: 2, label: "Spam", value: "Spam" },
  { id: 3, label: "Invalid", value: "Invalid" },
  { id: 4, label: "Dropped", value: "Dropped" },
  { id: 5, label: "Abused", value: "Abuse" },
];

export const failedStatsCampaignsStatusFilter = [
  {
    id: 0,
    label: "All Campaigns",
    value: "all",
  },

  {
    id: 2,
    label: "My Campaigns",
    value: "my",
  },
  {
    id: 3,
    label: "Team's Campaigns",
    value: "team",
  },
];
